import { JSX } from 'react';

import { Flex } from 'components/layout';
import { useQuickQuoteCurrency } from 'pages/QuoteView/Quoting/RequestQuickQuote/hooks/useQuickQuoteCurrency';
import { Maybe } from 'types/UtilityTypes';
import { CurrencyOption } from 'types/enums/CurrencyOptions';
import { cn } from 'utils/shadcn';

const CURRENCY_OPTIONS = [CurrencyOption.USD, CurrencyOption.CAD];

export function QuickQuoteCurrencyToggle(): Maybe<JSX.Element> {
  const { isEnabled, selectedCurrency, setSelectedCurrency } =
    useQuickQuoteCurrency();

  if (!isEnabled || !setSelectedCurrency) {
    return null;
  }

  return (
    <Flex justify='center' className='mt-2 w-full'>
      <Flex
        role='group'
        aria-label='Quote currency'
        className='rounded-md border border-neutral-200 bg-neutral-100 p-0.5'
      >
        {CURRENCY_OPTIONS.map((option) => {
          const isSelected = selectedCurrency === option;

          return (
            <button
              key={option}
              type='button'
              aria-pressed={isSelected}
              className={cn(
                'rounded px-2.5 py-1 text-xs font-medium transition-colors',
                isSelected
                  ? 'bg-brand-500 text-neutral-50 shadow-sm'
                  : 'text-neutral-600 hover:text-neutral-900'
              )}
              onClick={() => setSelectedCurrency(option)}
            >
              {option}
            </button>
          );
        })}
      </Flex>
    </Flex>
  );
}
